/**
 * Current tenant id (and optional backend URL) for the API layer.
 * Set by TenantContext when tenant is resolved; read by HttpApis when building headers.
 * When multi-tenant is disabled or tenant is not found, these stay null.
 */
let currentTenantId = null;
let currentTenantBackendUrl = null;

export function getTenantId() {
  return currentTenantId;
}

export function setTenantId(tenantId) {
  currentTenantId = tenantId ?? null;
}

export function getTenantBackendUrl() {
  return currentTenantBackendUrl;
}

/**
 * Optional: set a tenant-specific backend base URL (overrides REACT_APP_BASE_BACKEND_URL when set).
 * Call with null to use default again.
 */
export function setTenantBackendUrl(url) {
  currentTenantBackendUrl = url ?? null;
}
